import useDocumentTitle from "../hooks/useDocumentTitle";
import SectionLabel from "../components/SectionLabel";

export default function Impressum() {
  useDocumentTitle(
    "Impressum",
    "Impressum und rechtliche Angaben für Livinora Interior Concepts — ein gemeinsames Projekt von Wilhelm Schildmeyer GmbH & Co. KG und WHP Digital Solutions GmbH."
  );

  return (
    <div data-testid="page-impressum" className="pt-28 sm:pt-32 md:pt-44 pb-24 md:pb-32">
      <div className="container-livinora max-w-3xl">
        <SectionLabel index="∞" text="Impressum" />
        <h1 className="display-xl mt-7 text-[40px] sm:text-[56px] md:text-[72px] text-balance">
          Impressum
        </h1>
        <p className="prose-livinora prose-livinora--lead mt-8">
          Livinora Interior Concepts ist ein gemeinsames Projekt der Wilhelm Schildmeyer GmbH & Co. KG
          und der WHP Digital Solutions GmbH.
        </p>

        {/* Project partners */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          <PartnerCard
            label="Projektpartner · Möbel & Fertigung"
            name="Wilhelm Schildmeyer GmbH & Co. KG"
            address={["Sachsenweg 55", "32547 Bad Oeynhausen", "Deutschland"]}
            testId="impressum-partner-schildmeyer"
          />
          <PartnerCard
            label="Projektpartner · Digital & Plattform"
            name="WHP Digital Solutions GmbH"
            address={["Schuckertstraße 3", "48153 Münster", "Deutschland"]}
            testId="impressum-partner-whp"
          />
        </div>

        <div className="mt-14 space-y-12 text-[color:var(--livinora-ink)]">
          <LegalSection title="Kontakt">
            <Placeholder label="E-Mail" />
            <Placeholder label="Telefon" />
          </LegalSection>

          <LegalSection title="Vertretungsberechtigte Personen">
            <Placeholder block />
          </LegalSection>

          <LegalSection title="Registereintrag">
            <Placeholder label="Registergericht" />
            <Placeholder label="Handelsregisternummer" />
          </LegalSection>

          <LegalSection title="Umsatzsteuer-Identifikationsnummer">
            <Placeholder label="USt-IdNr. gemäß § 27 a Umsatzsteuergesetz" />
          </LegalSection>

          <LegalSection title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
            <Placeholder label="Name" />
            <Placeholder label="Anschrift" />
          </LegalSection>

          <LegalSection title="Haftung für Inhalte">
            <p className="prose-livinora">
              Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für Richtigkeit,
              Vollständigkeit und Aktualität wird jedoch keine Gewähr übernommen. Als Diensteanbieter
              sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            </p>
          </LegalSection>

          <LegalSection title="Haftung für Links">
            <p className="prose-livinora">
              Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte kein Einfluss
              besteht. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber verantwortlich. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
            </p>
          </LegalSection>
        </div>
      </div>
    </div>
  );
}

function PartnerCard({ label, name, address, testId }) {
  return (
    <div className="card-depth p-6 sm:p-7" data-testid={testId}>
      <span className="micro-label">{label}</span>
      <h3 className="serif text-xl sm:text-[22px] mt-4 leading-tight">{name}</h3>
      <address className="mt-3 not-italic text-sm text-[color:var(--livinora-muted)] leading-[1.85]">
        {address.map((line) => <span key={line} className="block">{line}</span>)}
      </address>
    </div>
  );
}

function LegalSection({ title, children }) {
  return (
    <section className="border-t border-[color:var(--livinora-hairline)] pt-8">
      <h2 className="micro-label">{title}</h2>
      <div className="mt-4 space-y-2">{children}</div>
    </section>
  );
}

function Placeholder({ label, block }) {
  if (block) {
    return (
      <p className="text-[color:var(--livinora-stone-deep)] italic">
        [bitte ergänzen]
      </p>
    );
  }
  return (
    <p className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-3">
      <span className="text-[10.5px] uppercase tracking-[0.22em] text-[color:var(--livinora-stone-deep)] sm:min-w-[200px]">
        {label}
      </span>
      <span className="text-[color:var(--livinora-stone-deep)] italic">[bitte ergänzen]</span>
    </p>
  );
}
